/**
 * @module geo/payload/facade
 */
import { Geometry } from "geojson";

import { MapOptions } from "../../types/map";

/**
 * Zoom in on map(by a factor of two).
 * @since v 2.0.1
 * @see [[GeoApp.transform]]
 */
export class UTIL_CONVERT_PROJ {
  map?: MapOptions | null;

  /**
   * the source parameters
   * geometry and crs
   */
  in: {
    geometry: Geometry;
    crs: string;
  };
  /**
   * the destineation paramters (crs)
   */
  out: { crs: string };
  constructor(options: any) {
    this.in = options.in;
    this.out = options.out;
  }
}
